import { render, staticRenderFns } from "./SortNumberUp.vue?vue&type=template&id=b3d58d6a"
import script from "./SortNumberUp.vue?vue&type=script&lang=js"
export * from "./SortNumberUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports